<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading8">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse8" aria-expanded="false" aria-controls="collapse8">
                Invullen box 3 bezittingen en schulden
            </button>
        </h2>
        <div id="collapse8" class="accordion-collapse collapse" aria-labelledby="heading8"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <b>Box 3 bezittingen en schulden meer dan grensbedrag voor bijv. toeslagen</b><br/>
                Het invullen van de box 3-bezittingen en schulden is van belang als op 1 januari {{ this.year }} het
                totaal van de bankrekeningen, andere bezittingen en schulden boven een grensbedrag uitkomt. Het gaat
                hierbij om bezittingen van aangever, de fiscale partner en de minderjarige kinderen van aangever en
                fiscale partner.
                <div class="space10"></div>

                Dit grensbedrag is het maximale bedrag voor bepaalde inkomensafhankelijke regelingen, zoals bij
                huurtoeslag en rechtsbijstand. Je moet daarom de bezittingen en schulden per 1 januari {{ this.year }}
                aangeven als deze hoger zijn dan dit
                grensbedrag van € {{ this.vrijstellingRegelingen | number: '1.0-0' }}. Of als er een
                fiscaal partner is € {{ this.vrijstellingRegelingen * 2 | number: '1.0-0' }}.
                <div class="space10"></div>

                <b>Box 3 bezittingen en schulden meer dan vrijstelling</b><br/>
                Voor de inkomstenbelasting is het heffingsvrij box 3-vermogen per 1 januari {{ this.year }}
                € {{ this.vrijstellingBox3  | number: '1.0-0' }}, of
                € {{ this.vrijstellingBox3 * 2  | number: '1.0-0' }} als er een fiscale partner is.
                Bij de berekening van de inkomstenbelasting houden we rekening met deze vrijstelling.
                <div class="space10"></div>


            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading0">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse0" aria-expanded="false" aria-controls="collapse0">
                Bankrekeningen
            </button>
        </h2>
        <div id="collapse0" class="accordion-collapse collapse" aria-labelledby="heading0"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Het gaat hier om al je bank- en spaarrekeningen in Nederland en buiten Nederland die je op 1
                januari {{ this.year }} had.

                <div class="space10"></div>
                <b>Negatief saldo</b><br/>
                Is het saldo van de bankrekening op 1 januari {{ this.year }} negatief? Dan vul je deze bankrekening in
                bij de schulden in box 3.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading10">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse10" aria-expanded="false" aria-controls="collapse10">
                Negatieven bankrekeningen
            </button>
        </h2>
        <div id="collapse10" class="accordion-collapse collapse" aria-labelledby="heading10"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Het kan uiteraard voorkomen dat er sprake is van een negatieve bankrekening (roodstaan) op peildatum.
                Voor de belastingaangifte wordt dit dan gezien als een 'Schuld box 3' en NIET als een saldo
                bankrekening.
                Is het saldo van de bankrekening op 1 januari {{ this.year }} dus negatief? Dan vul je deze bankrekening
                in bij de schulden in box 3.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading4">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse4" aria-expanded="false" aria-controls="collapse4">
                Groene bankrekeningen
            </button>
        </h2>
        <div id="collapse4" class="accordion-collapse collapse" aria-labelledby="heading4"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Als spaarder kun je geld inleggen in een groenfonds. Je krijgt een lagere vergoeding van de
                bank, maar heeft wel een belastingvoordeel. De bank kan het geld bijvoorbeeld uitlenen aan projecten
                voor circulaire economie, duurzame mobiliteit of duurzame landbouw. De projecten moeten voldoen aan de
                eisen uit de Regeling groenprojecten en hebben een groenverklaring nodig.
                <div class="space10"></div>
                Op <a target="_blank"
                      href="https://www.rvo.nl">rvo.nl</a>
                staat een overzicht van groene investeringen met belastingvoordeel. Staat je bankrekening of belegging
                hierbij? Dan hebt je recht op vrijstelling en heffingskorting voor deze groene investering.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse1" aria-expanded="false" aria-controls="collapse1">
                Premiedepots en aandeel VvE
            </button>
        </h2>
        <div id="collapse1" class="accordion-collapse collapse" aria-labelledby="heading1"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Een premiedepot is een (geblokkeerde) bankrekening waarvan het tegoed is bestemd voor het betalen van
                bijvoorbeeld verzekeringspremies. Je moet het tegoed van het premiedepot op 1 januari {{ this.year }}
                aangeven als bankrekening in box 3.
                <div class="space10"></div>

                Had je een aandeel in het vermogen van een Vereniging van Eigenaren (VvE)? Of geld op een
                derdenrekening, zoals bij een notaris of gerechtsdeurwaarder? Dan hoort je aandeel ook bij je bank- en
                spaarrekeningen.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading2">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse2" aria-expanded="false" aria-controls="collapse2">
                Verplaatsen van bezittingen en schulden rondom de peildatum
            </button>
        </h2>
        <div id="collapse2" class="accordion-collapse collapse" aria-labelledby="heading2"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Over bank- en spaartegoeden betaalt je minder belasting dan over beleggingen en andere belaste
                bezittingen. Zet je om die reden overige bezittingen (zoals beleggingen) rondom 1 januari (de peildatum)
                tijdelijk om in bank- en spaartegoeden? Of ga je tijdelijk meer schulden aan? Als je hiervoor geen
                zakelijke redenen hebt, dan kan er sprake zijn van 'peildatumarbitrage'. Er zijn in dit geval speciale
                regels waardoor verplaatsing van de bezittingen en schulden niet leidt tot een lagere belastingheffing.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading3">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse3" aria-expanded="false" aria-controls="collapse3">
                Bezittingen en schulden verplaatsen van box 3 en weer terug
            </button>
        </h2>
        <div id="collapse3" class="accordion-collapse collapse" aria-labelledby="heading3"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Vallen je bezittingen of schulden tijdelijk niet meer in box 3 maar in box 1 (inkomen uit werk en
                woning) of box 2 (inkomen uit aanmerkelijk belang)? En gaan deze daarna weer terug naar box 3? Als de
                bezittingen of schulden op 1 januari {{ this.year }} in box 1 of 2 vallen en later dat jaar weer in box
                3, dan moet je de werkelijke inkomsten aangeven als inkomen uit werk en woning of inkomen uit
                aanmerkelijk belang. Je moet daarnaast je bezittingen ook nog meetellen bij je voordeel uit sparen en
                beleggen (in box 3) als de verplaatsing:
                <li class="list">niet meer dan 3 achtereenvolgende maanden duurde</li>
                <li class="list">meer dan 3 achtereenvolgende maanden, maar niet meer dan 6 achtereenvolgende maanden
                    duurde.<br>Je
                    hoeft deze bezittingen in dit geval niet mee te rekenen in box 3 als je aannemelijk kunt maken dat
                    de bezitting om zakelijke redenen is verplaatst.
                </li>
                <li class="list">meer dan 6 achtereenvolgende maanden, maar niet meer dan 18 achtereenvolgende maanden
                    duurde en er
                    sprake is van verplaatsing naar een vrijgestelde beleggingsinstelling (Vbi) of een buitenlands
                    beleggingslichaam.<br/>
                    De bezittingen moeten dan ten minste een deel van die periode een regulier (forfaitair) voordeel
                    opleveren uit de aandelen in of winstbewijzen van dat lichaam.
            </div>
        </div>
    </div>

</div>

